import { render, staticRenderFns } from "./studentQr.vue?vue&type=template&id=245a6e5e&scoped=true"
import script from "./studentQr.vue?vue&type=script&lang=js"
export * from "./studentQr.vue?vue&type=script&lang=js"
import style0 from "./studentQr.vue?vue&type=style&index=0&id=245a6e5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245a6e5e",
  null
  
)

export default component.exports